import { useTranslation, Trans } from "react-i18next";

import check from '../../img/Products/check.svg'

function WhyChoose() {

  const { t } = useTranslation();

  return (
    <div className="relative overflow-hidden mt-[80px] xl:mt-[140px]">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col">
            <p className="text-[20px] xl:text-[40px] poppins font-[500] text-[#061A77] xl:max-w-[600px] leading-[1.4]">{t('investment.36')}</p>
            <div className="grid grid-cols-1 xl:grid-cols-2 mt-[20px] xl:mt-[40px] gap-[20px]">
                <div className="flex items-start gap-[10px] xl:gap-[60px]">
                    <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                    <div>
                        <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('investment.37')}</p>
                        <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('investment.38')}</Trans></p>
                    </div>
                </div>
                <div className="flex items-start gap-[10px] xl:gap-[60px]">
                    <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                    <div>
                        <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('investment.39')}</p>
                        <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('investment.40')}</Trans></p>
                    </div>
                </div>
                <div className="flex items-start gap-[10px] xl:gap-[60px]">
                    <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                    <div>
                        <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('investment.41')}</p>
                        <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('investment.42')}</Trans></p>
                    </div>
                </div>
                <div className="flex items-start gap-[10px] xl:gap-[60px]">
                    <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                    <div>
                        <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('investment.43')}</p>
                        <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('investment.44')}</Trans></p>
                    </div>
                </div>
                <div className="flex items-start gap-[10px] xl:gap-[60px]">
                    <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                    <div>
                        <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('investment.45')}</p>
                        <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('investment.46')}</Trans></p>
                    </div>
                </div>
                <div className="flex items-start gap-[10px] xl:gap-[60px]">
                    <img src={check} className="flex-shrink-0 xl:mt-[5px]" alt="" />
                    <div>
                        <p className="text-[#1A0402] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2]">{t('investment.47')}</p>
                        <p className="mt-[12px] inter text-[14px] text-[#000000B2] xl:max-w-[404px]"><Trans>{t('investment.48')}</Trans></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default WhyChoose;
 